import { UPDATES } from '../shared/updates';

export const Updates = (state = UPDATES, action) => {
    switch (action.type) {
        default:
          return state;
      }
};
